import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:9090';
const API_TIMEOUT = process.env.VUE_APP_API_TIMEOUT
  ? parseInt(process.env.VUE_APP_API_TIMEOUT)
  : 100000;

const instance = axios.create({
  baseURL,
  timeout: API_TIMEOUT
});

// 请求拦截器：自动加token
instance.interceptors.request.use(config => {
  // 不给登录接口加token
  if (!config.url.includes('/api/User/Login')) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = token;
    }
  }
  return config;
}, error => Promise.reject(error));

// 响应拦截器：处理401状态码
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // 保存记住密码的信息
      const rememberLogin = localStorage.getItem('rememberLogin');
      
      // 清除本地存储的用户信息，但保留记住密码的信息
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('username');
      
      // 如果之前有记住密码的信息，重新保存
      if (rememberLogin) {
        localStorage.setItem('rememberLogin', rememberLogin);
      }
      
      // 显示提示信息并跳转到登录页面
      if (window.vueApp && window.vueApp.$toast) {
        window.vueApp.$toast.fail('登录超时或没有该操作权限,请重新登录');
        // 延迟跳转，确保提示信息显示完成
        setTimeout(() => {
          if (window.vueApp && window.vueApp.$router) {
            window.vueApp.$router.push('/login');
          }
        }, 1500);
      }
    }
    return Promise.reject(error);
  }
);

export default instance; 